import React, { useState, useEffect } from "react";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// react-router components
import { Routes, Route, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import { theme, themeRTL } from "theme/themeInitializer";

// import { authRoutes } from "routes";
import Main from "layouts/Main/Main";
import { ToastContainer } from "react-toastify";

import { setDirection, useMaterialUIController } from "context";
import Languages from "services/i18n/languages";
import i18n from "services/i18n/i18n";

const queryClient = new QueryClient();

export default function App() {
  const { pathname } = useLocation();
  const [controller, dispatch] = useMaterialUIController();
  const { darkMode, direction } = controller;


  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  useEffect(() => {
    updateLangugeSettings();
  }, []);



  const updateLangugeSettings = () => {
    const localLanguage = localStorage.getItem("language");
    let lang = "en";
    if (localLanguage) {
      lang = localLanguage;
    } else {
      localStorage.setItem("language", lang);
    }
    const langDirection: "rtl" | "ltr" = Languages.find((l) => l.key === lang)?.isRtl
      ? "rtl"
      : "ltr";
    
    setDirection(dispatch, langDirection);
    i18n.changeLanguage(lang);
  };

  const renderBody = () => {
    return (
      <React.Fragment>
        <CssBaseline />
        <Routes>
          <Route path="*" element={<Main />} />
        </Routes>
        <ToastContainer
          theme={(darkMode && "dark") || "light"}
          position={direction === "rtl" ? 'top-left' : 'top-right'}
          toastClassName="dark-toast"
          style={{ fontSize: "14px", fontFamily: "Roboto" }}
        />
      </React.Fragment>
    );
  };

  return (
    <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={direction === "rtl" ? themeRTL : theme}>{renderBody()}</ThemeProvider>
    </QueryClientProvider>
  );
}
